module.exports = __webpack_public_path__ + "static/media/rama.9881b030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/rama.jpg
// module id = 1291
// module chunks = 0